import { useTheme } from '@mui/material';
import { Serie } from '@nivo/line';

interface CustomNowMarkerProps {
    innerWidth: number;
    innerHeight: number;
    series: Serie[];
    selectedValue: string | number | undefined;
    markerColor?: string;
    markerBorderColor?: string;
    markerRadius?: number;
    strokeWidth?: number;
    markerPosition: { x: number; y: number } | null;
}

export function CustomNowMarker({ innerWidth, innerHeight, series, selectedValue, markerColor,  markerBorderColor, markerRadius, strokeWidth, markerPosition }: CustomNowMarkerProps) {
  const theme = useTheme();

  if (!series.length) return null;

  const currentPoint = markerPosition
    ? { position: markerPosition }
    : series[0].data.find((d: any) => d.data.x === selectedValue);

  if (!currentPoint || !currentPoint.position) return null;

  if (
    currentPoint.position.x < 0 ||
    currentPoint.position.x > innerWidth ||
    currentPoint.position.y < 0 ||
    currentPoint.position.y > innerHeight
  ) {
    return null;
  }

  const { x, y } = currentPoint.position;

  if (x < 0 || x > innerWidth || y < 0 || y > innerHeight) {
    return null;
  }

  return (
    <>
      <rect
        x={x - 1}
        y={0}
        width={2}
        height={innerHeight}
        fill={markerBorderColor ?? theme.palette.text.primary}
        style={{
          transition: 'all 0.2s ease-out',
        }}
      />
      <circle
        cx={x}
        cy={y}
        fill={markerColor ?? theme.palette.text.primary}
        stroke={markerBorderColor ?? theme.palette.text.primary}
        r={markerRadius ?? 6}
        strokeWidth={strokeWidth ?? 1}
        style={{
          transition: 'all 0.2s ease-out'
        }}
      />
    </>
  );
}